<template>
  <thead>
    <th>
      {{ I18n.t("table.number") }}
    </th>
    <th>
      {{ I18n.t("simple_form.labels.order_form.user") }}
    </th>
    <th>
      {{ I18n.t("employees.auctions_catalogs.date") }}
    </th>
    <th>
      {{ I18n.t("employees.auctions_catalogs.order_amount") }}
    </th>
    <th />
  </thead>
</template>

<script>
  export default {
    name: 'BidsTableHead',
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees_orders_panel/components/table/bids_table_head.vue?037654f9